/*
 * @Author: xuhuan
 * @Date: 2023-07-12 10:03:41
 * @Description: file content
 * @LastEditors: xuhuan
 */
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Layouts from "@/views/layouts/Index.vue";
import store from "@/store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: Layouts,
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("@/views/home/Index.vue"),
        meta: {
          title: "首页",
          icon: "House",
          code: "HomeMenu",
        },
      },
      {
        path: "/product",
        name: "Product",
        children: [
          {
            path: "/product",
            name: "Product",
            component: () => import("@/views/product/Index.vue"),
            meta: {
              title: "商品列表",
            },
          },
          {
            path: "/type",
            name: "Type",
            component: () => import("@/views/product/TypeList.vue"),
            meta: {
              title: "商品分类",
            },
          },
          {
            path: "/supplier",
            name: "Supplier",
            component: () => import("@/views/product/Supplier.vue"),
            meta: {
              title: "供应商管理",
            },
          },
          {
            path: "/attribute",
            name: "Attribute",
            component: () => import("@/views/product/Attribute.vue"),
            meta: {
              title: "属性管理",
            },
          },
          {
            path: "/review",
            name: "Review",
            component: () => import("@/views/product/Review.vue"),
            meta: {
              title: "商品审核",
            },
          },
          // {
          //   path: "/tourism",
          //   name: "Tourism",
          //   component: () => import("@/views/product/Tourism.vue"),
          //   meta: {
          //     title: "旅游卡",
          //   },
          // },
        ],
        meta: {
          title: "商品管理",
          icon: "Menu",
          code: "ProductManagerMenu",
        },
      },
      {
        path: "/member",
        name: "Member",
        children: [
          {
            path: "/member",
            name: "Member",
            component: () => import("@/views/member/Index.vue"),
            meta: {
              title: "用户列表",
            },
          },
        ],
        meta: {
          title: "用户管理",
          icon: "User",
          code: "UserManagerMenu",
        },
      },
      {
        path: "/shop",
        name: "ShopType",
        children: [
          {
            path: "/shopType",
            name: "ShopType",
            component: () => import("@/views/shop/Type.vue"),
            meta: {
              title: "店铺分类",
            },
          },
          {
            path: "/shopIndex",
            name: "ShopIndex",
            component: () => import("@/views/shop/Index.vue"),
            meta: {
              title: "店铺列表",
            },
          },
          {
            path: "/business",
            name: "Business",
            component: () => import("@/views/shop/Business.vue"),
            meta: {
              title: "商家列表",
            },
          },
        ],
        meta: {
          title: "店铺管理",
          icon: "TakeawayBox",
          code: "ShopManagerMenu",
        },
      },
      {
        path: "/order",
        name: "Order",
        children: [
          {
            path: "/order",
            name: "Order",
            component: () => import("@/views/order/Index.vue"),
            meta: {
              title: "订单列表",
            },
          },
          // {
          //   path: "/storesOrder",
          //   name: "StoresOrder",
          //   component: () => import("@/views/storesOrder/Index.vue"),
          //   meta: {
          //     title: "商户订单",
          //   },
          // },
          // {
          //   path: "/recharge",
          //   name: "Recharge",
          //   component: () => import("@/views/order/recharge.vue"),
          //   meta: {
          //     title: "充值订单",
          //   },
          // },
          {
            path: "/afterSales",
            name: "AfterSales",
            component: () => import("@/views/order/afterSales.vue"),
            meta: {
              title: "售后列表",
            },
          },
        ],
        meta: {
          title: "订单管理",
          icon: "Histogram",
          code: "OrderManagerMenu",
        },
      },
      {
        path: "/admin",
        name: "Admin",
        children: [
          {
            path: "/admin",
            name: "Admin",
            component: () => import("@/views/admin/Index.vue"),
            meta: {
              title: "管理员列表",
            },
          },
          {
            path: "/role",
            name: "Role",
            component: () => import("@/views/admin/RoleIndex.vue"),
            meta: {
              title: "角色管理",
            },
          },
          {
            path: "/authority",
            name: "Authority",
            children: [
              {
                path: "/authorityset",
                name: "AuthoritySet",
                component: () =>
                  import("@/views/sys/authority/setting/Index.vue"),
                meta: {
                  title: "权限配置",
                },
              },
              {
                path: "/authoritygroup",
                name: "AuthorityGroup",
                component: () =>
                  import("@/views/sys/authority/group/Index.vue"),
                meta: {
                  title: "权限组",
                },
              },
            ],
            meta: {
              title: "权限管理",
              icon: "Rank",
            },
          },
        ],
        meta: {
          title: "系统管理",
          icon: "Setting",
          code: "SystemManagerMenu",
        },
      },
      {
        path: "/marketing",
        name: "Marketing",
        children: [
          {
            path: "/settlement",
            name: "Settlement",
            component: () => import("@/views/marketing/Settlement.vue"),
            meta: {
              title: "营销结算",
            },
          },
          {
            path: "/region",
            name: "Region",
            component: () => import("@/views/marketing/Region.vue"),
            meta: {
              title: "区域代理管理",
            },
          },
          {
            path: "/productAgent",
            name: "ProductAgent",
            component: () => import("@/views/product/ProductAgent.vue"),
            meta: {
              title: "商品代理",
            },
          },
          {
            path: "/marketingConfiguration",
            name: "MarketingConfiguration",
            component: () => import("@/views/product/MarketingConfiguration.vue"),
            meta: {
              title: "商品营销配置",
            },
          },
          {
            path: "/operationalRoleSetMan",
            name: "OperationalRoleSetMan",
            component: () => import("@/views/marketing/OperationalRoleSetMan.vue"),
            meta: {
              title: "运营角色配置列表",
            },
          },
        ],
        meta: {
          title: "营销管理",
          icon: "SetUp",
          code: "SaleManagerMenu",
        },
      },
      {
        path: "/pay",
        name: "Pay",
        children: [
          {
            path: "/pay",
            name: "pay",
            component: () => import("@/views/pay/Pay.vue"),
            meta: {
              title: "缴费列表",
            },
          },
        ],
        meta: {
          title: "缴费管理",
          icon: "Goods",
          code: "PaymentManagerMenu",
        },
      },
      {
        path: "/adManager",
        name: "AdManager",
        children: [
          {
            path: "/slideType",
            name: "SlideType",
            component: () => import("@/views/slide/type/Index.vue"),
            meta: {
              title: "广告分类",
            },
          },
          {
            path: "/slide",
            name: "Slide",
            component: () => import("@/views/slide/Index.vue"),
            meta: {
              title: "广告图",
            },
          },
          {
            path: "/homeProductSetting",
            name: "HomeProductSetting",
            component: () => import("@/views/mallOperation/HomeSetting.vue"),
            meta: {
              title: "首页商品配置",
            },
          },

        ],
        meta: {
          title: "商城运营",
          icon: "Film",
          code: "AdManager",
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/Index.vue"),
    meta: {
      title: "登录",
    },
  },
];

//添加动态路由
// const trends_router = [
//   {
//     path: "/home",
//     name: "home",
//     component: () => import("@/views/HomeView.vue"),
//   },
//   {
//     path: "/about",
//     name: "about",
//     component: () => import("@/views/AboutView.vue"),
//   },
// ];
// routes[0].children=routes[0].children?.concat(trends_router)

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (!localStorage.getItem("routes")) {
    let adminInfo: any = localStorage.getItem("adminInfo");
    adminInfo = adminInfo ? JSON.parse(adminInfo) : null;
    if (adminInfo && adminInfo.roleName == "超级管理员") {
      localStorage.setItem("routes", JSON.stringify(routes[0].children));
    } else {
      //调用api处理菜单权限
      let routesItem: any = [];
      let arr = routes[0].children;
      let menuRole: any = localStorage.getItem("menuRole");
      if (menuRole) {
        menuRole = JSON.parse(menuRole);
        arr?.map((item: any) => {
          if (menuRole.some((r: any) => r.code == item.meta.code)) {
            routesItem.push(item);
          }
        });
        localStorage.setItem("routes", JSON.stringify(routesItem));
      }
    }
  }
  document.title =
    typeof to.meta.title == "string" ? to.meta.title : "泉融合管理平台";
  if (localStorage.getItem("adminInfo") || to.path == "/login") next();
  else router.push("/login");
});

export default router;
